import { Component } from "@/decorators";
import PacoteEntregaModel from "@/models/pacoteEntregaModel";
import pacoteEntregaService from "@/services/pacoteEntregaService";

import EditComponentBase from "../editComponentBase";

@Component
export default class PacoteEntregaEditComponent extends EditComponentBase<PacoteEntregaModel> {
    private async beforeMount() {
        await this.setPropsCached(pacoteEntregaService, "pacote_entrega", new PacoteEntregaModel());
    }
}
